'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$37() {
  this.bix = null;
  this.biv = null;
  this.biw = false;
  this.bit = null;
  this.biu = false;
  this.biy = false;
  this.biz = false;
  this.bix = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$37 as $c_Lpresto_PrestoRouter$$anon$37 };
$p = $c_Lpresto_PrestoRouter$$anon$37.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$37;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$37() {
}
export { $h_Lpresto_PrestoRouter$$anon$37 as $h_Lpresto_PrestoRouter$$anon$37 };
$h_Lpresto_PrestoRouter$$anon$37.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bix;
});
$p.t = (function() {
  if ((!this.biw)) {
    this.biv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("str", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.biw = true;
  }
  return this.biv;
});
$p.ag = (function() {
  if ((!this.biu)) {
    this.bit = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.biu = true;
  }
  return this.bit;
});
$p.v = (function() {
  if ((!this.biz)) {
    this.biy = false;
    this.biz = true;
  }
  return this.biy;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$37 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$37, "presto.PrestoRouter$$anon$37", ({
  Ob: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$37 as $d_Lpresto_PrestoRouter$$anon$37 };
//# sourceMappingURL=presto.-Presto-Router$$anon$37.js.map
